// extracted by mini-css-extract-plugin
export default {"markdownHeroContainer":"Readme-module__markdownHeroContainer__LRmMNl2","markdownHeroLogo":"Readme-module__markdownHeroLogo__RZimSlr"};